import { jsx as _jsx } from "react/jsx-runtime";
import { AuthProvider } from "./Auth";
import { LoadingRequestProvider } from "./BackdropLoaderContext";
import { SidebarProvider } from "./SidebarContext";
export var AppProviders = function (_a) {
    var children = _a.children;
    return _jsx(AuthProvider, { children: _jsx(SidebarProvider, { children: _jsx(LoadingRequestProvider, { children: children }, void 0) }, void 0) }, void 0);
};
